<template>
  <div class="users-link py-4">
    <ApolloQuery :query="query">
      <template v-slot="{ result: { loading, error, data } }">
        <div
          class="text-gray-700 text-base p-4 border-t border-gray-400"
          v-if="loading || !data"
        >
          Caricamento...
        </div>

        <!-- Error -->
        <div
          class="text-gray-700 text-base p-4 border-t border-gray-400"
          v-else-if="error"
        >
          Si è verificato un errore
        </div>
        <!-- Result -->
        <ul v-else-if="data && data.allEditors && data.allEditors.data.length">
          <li
            v-for="user of data.allEditors.data"
            :key="user._id"
            class="border-t border-gray-400"
          >
            <router-link
              class="block w-full p-4"
              :to="{
                name: 'EditUser',
                params: { id: user._id, tenant: $route.params.tenant },
              }"
            >
              {{ user.displayName }}

              <span class="inline-block text-gray-600 ml-4">
                &lt;{{ user.email }}&gt;
              </span>
            </router-link>
          </li>
        </ul>

        <!-- No result -->
        <div
          class="text-gray-700 text-base p-4 border-t border-gray-400"
          v-else
        >
          Nessun utente presente
        </div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import GET_USERS from '@/graphql/GetEditors.gql'

export default {
  data() {
    return {
      query: GET_USERS,
    }
  },
}
</script>

<style lang="scss" scoped></style>
